import React from 'react';
type ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashesProps = {
  version: object;
};
const ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashes: React.SFC<
  ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashesProps
> = props => {
  let version = props.version,
    sha1 = version.sha1,
    sha2 = version.sha2;
  return (
    <div className="grid pt-">
      <div className="grid__item col-1-1 pt-">
        <div className="grid bo--1 border-color--muted font--12 p-">
          File hashes takes the characters in the source code file and converts them to a string
          hash. If any characters have change in downloading a file, the hash will be different than
          this value, indicating that something went wrong in the install and that the file may be
          corrupt.
        </div>
      </div>
      <div className="grid__item col-1-1 pt">
        <div className="grid grid--middle flex">
          <div className="grid__item col-1-3 font--h7 phone--pl0">SHA-1:</div>
          <div className="grid__item col-2-3 phone--pl0">
            <div className="font-family--code bg-color--black-dark color--white col-1-1 ph-- pv- text--overflow phone--no-overflow">
              {sha1}
            </div>
          </div>
        </div>
        <div className="grid grid--middle flex pt-">
          <div className="grid__item col-1-3 font--h7 phone--pl0">SHA-256:</div>
          <div className="grid__item col-2-3 phone--pl0">
            <div className="font-family--code bg-color--black-dark color--white col-1-1 ph-- pv- text--overflow phone--no-overflow">
              {sha2}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ArtifactViewMainContentSignaturesComponentVersionDetailsFileHashes;
